import { createChart, CandlestickSeries, HistogramSeries } from "lightweight-charts"

// Candle up/down colors, shared with indicator and marker rendering.
export const UP = "#34d399"
export const DOWN = "#f2555f"

// Creates a dark candlestick + volume chart matched to its .surface container.
// Returns the chart plus its candle and volume series. Shared by the
// trading-pair price chart and the bot chart so their styling stays in sync.
export function createCandleChart(containerEl) {
  // Match the canvas to the .surface background so the chart does not render
  // a different shade than the rest of the page.
  const surfaceColor = getComputedStyle(containerEl).backgroundColor

  const chart = createChart(containerEl, {
    autoSize: true,
    layout: {
      background: { color: surfaceColor },
      textColor: "#9ca3ad"
    },
    grid: {
      vertLines: { color: "#1d1f24" },
      horzLines: { color: "#1d1f24" }
    },
    rightPriceScale: { borderColor: "#2b2e34" },
    timeScale: { borderColor: "#2b2e34", timeVisible: true }
  })

  const candleSeries = chart.addSeries(CandlestickSeries, {
    upColor: UP,
    downColor: DOWN,
    borderUpColor: UP,
    borderDownColor: DOWN,
    wickUpColor: UP,
    wickDownColor: DOWN
  })

  const volumeSeries = chart.addSeries(HistogramSeries, {
    priceFormat: { type: "volume" },
    priceScaleId: "volume"
  })
  chart.priceScale("volume").applyOptions({
    scaleMargins: { top: 0.82, bottom: 0 }
  })

  return { chart, candleSeries, volumeSeries }
}
